const t1Items = document.querySelectorAll('li[data-mega-tab]');
const t2Items = document
  .querySelector('.mega-menu-lower')
  .querySelectorAll('[data-mega-tab]');

// Show relevant lower menu on hover
t1Items.forEach(t1 => {
  const t1Idx = t1.getAttribute('data-mega-tab');
  const header = document.getElementById('shopify-section-header');
  t1.addEventListener('mouseover', e => {
    header.classList.add('mega-open');
    t1Items.forEach(t1i => t1i.classList.remove('mega-t1-active'));
    t2Items.forEach(t2 => {
      t2.classList.remove('t2-fade-in');
      const t2Idx = t2.getAttribute('data-mega-tab');
      if (t2Idx == t1Idx) {
        t1.classList.add('mega-t1-active');
        t2.classList.add('t2-fade-in');
      }
    });
  });
});

// remove on leave t1 wrapper or lower box
/*
const header = document.querySelector('#header');
header.addEventListener('mouseleave', (e) => {
  t2Items.forEach((t2) => {
    t2.classList.remove('t2-fade-in');
  });
});
*/
const lowerMega = document.querySelector('.mega-menu-lower');

function closeMegaMenu() {
  t2Items.forEach(t2 => t2.classList.remove('t2-fade-in'));
  t1Items.forEach(t1i => t1i.classList.remove('mega-t1-active'));

  const header = document.getElementById('shopify-section-header');
  header.classList.remove('mega-open');
}

// lower mega menu listener
lowerMega.addEventListener('mouseleave', closeMegaMenu);

// Catch when mouse leaves the window (top of screen)
document.addEventListener('mouseleave', e => {
  if (e.clientY <= 0) closeMegaMenu();
});

lowerMega.classList.remove('hide');
